import { ChatMessageDisplayConfigButton } from '../../step/ChatMessageDisplayConfig';
import { PinButton } from '../../step/PinButton';
import { ResponseTemplatingButton } from '../../step/ResponseTemplatingButton';
import { CommentButton } from '../../feedback/CommentButton';
import { ModelResponseSelectorTab } from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/ModelResponseSelector/ModelResponseSelectorTabsWrapper';
import {
  DEFAULT_MODEL_SELECTOR_TITLE,
  DEFAULT_MODEL_SELECTOR_SUBTITLE,
} from '@scale/shared/types/chat';
import { StepCard } from 'react-scale/components/scalers/tasks/ThreadedInteraction/step/StepCard';
import { useContext } from 'react';
import { ChatTaskContext } from 'react-scale/components/scalers/tasks/ThreadedInteraction/contexts/ChatTaskContext';

interface ModelResponseSelectorCardHeaderProps {
  step: {
    title?: string;
    subtitle?: string;
    type: string;
    turn: number;
  };
  responseIndex: number;
  showTwoCandidateDiffResult: boolean;
  tab: ModelResponseSelectorTab;
  setTab: (tab: ModelResponseSelectorTab) => void;
  isPinnable: boolean;
  isPinnedView: boolean;
  chatMessageDisplayConfig: any;
  useMarkdownDisplay: boolean;
  updateMarkdownConfig: (config: any) => void;
  toggleChatMessageDisplayType: () => void;
  readOnly?: boolean | undefined;
  usedForProcessSupervision: boolean;
  stacked: boolean;
  setStacked: (stacked: boolean) => void;
  chatPrompt: string;
}

export const ModelResponseSelectorCardHeader: React.FC<ModelResponseSelectorCardHeaderProps> = ({
  step,
  responseIndex,
  showTwoCandidateDiffResult,
  tab,
  setTab,
  chatMessageDisplayConfig,
  useMarkdownDisplay,
  updateMarkdownConfig,
  toggleChatMessageDisplayType,
  usedForProcessSupervision,
  stacked,
  setStacked,
  chatPrompt,
}) => {
  const { title, subtitle, type, turn } = step;

  const taskContext = useContext(ChatTaskContext);

  return (
    <StepCard.Header>
      <StepCard.HeaderLeft>
        <StepCard.Icon icon="award" />
        <StepCard.HeaderColumn>
          <StepCard.Title>{title || DEFAULT_MODEL_SELECTOR_TITLE}</StepCard.Title>
          <StepCard.Subtitle>
            <div className="flex justify-between">
              {subtitle || DEFAULT_MODEL_SELECTOR_SUBTITLE}
            </div>
          </StepCard.Subtitle>
        </StepCard.HeaderColumn>
      </StepCard.HeaderLeft>
      <StepCard.HeaderRight>
        {usedForProcessSupervision && (
          <>
            <p>PS</p>
            <StepCard.Button
              icon="clipboard"
              tooltip="Copy chat prompt"
              onClick={() => navigator.clipboard.writeText(chatPrompt)}
              onMouseEnter={e => {
                e.currentTarget.title = chatPrompt;
              }}
            />
          </>
        )}

        {taskContext.enableUnifiedFeedback && (
          <>
            <StepCard.Button
              icon="layer-group"
              selected={!stacked}
              tooltip="Show candidates side-by-side"
              onClick={() => setStacked(false)}
              iconProps={{ rotation: 270 }}
            />
            <StepCard.Button
              icon="layer-group"
              selected={stacked}
              tooltip="Show candidates stacked top-to-bottom"
              onClick={() => setStacked(true)}
            />
          </>
        )}
        {showTwoCandidateDiffResult && (
          <StepCard.Button
            icon="file-plus-minus"
            selected={tab === ModelResponseSelectorTab.Diff}
            tooltip={tab === ModelResponseSelectorTab.Markdown ? 'Show Diff' : 'Hide Diff'}
            onClick={() =>
              setTab(
                tab === ModelResponseSelectorTab.Markdown
                  ? ModelResponseSelectorTab.Diff
                  : ModelResponseSelectorTab.Markdown,
              )
            }
          />
        )}
        {!taskContext.enableUnifiedFeedback && (
          <CommentButton visible={true} childId={`${type}-${responseIndex}`} turnIndex={turn} />
        )}
        <ResponseTemplatingButton
          childId={`${type}-${responseIndex}`}
          metadata={{ stepIndex: responseIndex }}
        />
        <PinButton responseIndex={responseIndex} />
        <ChatMessageDisplayConfigButton
          chatMessageDisplayConfig={chatMessageDisplayConfig}
          useMarkdownDisplay={useMarkdownDisplay}
          updateMarkdownConfig={updateMarkdownConfig}
          toggleChatMessageDisplayType={toggleChatMessageDisplayType}
        />
      </StepCard.HeaderRight>
    </StepCard.Header>
  );
};
